<template lang="html">
  <span
    class="flat-icon"
    :class="cssClass"
    :style="computedStyle" />
</template>

<script>
export default {
  name: 'FlatIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 64
    }
  },
  computed: {
    computedStyle () {
      const addPx = n => n + 'px'
      return {
        width: addPx(this.size),
        height: addPx(this.size)
      }
    },
    cssClass () {
      return 'picto-' + this.name
    }
  }
}
</script>

<style lang="scss">
$pictos: (
  adventure,
  archives,
  book,
  camera,
  camera-white,
  camper-van,
  contract,
  cycling,
  close,
  dark,
  double-decker,
  el-climb,
  el-dist,
  el-down,
  el-min,
  el-max,
  encyclopedia,
  error,
  footwear,
  free,
  gear,
  gear-2,
  geo-white,
  geo,
  gh-away,
  gh-keep-left,
  gh-turn-sharp-left,
  gh-turn-left,
  gh-turn-slight-left,
  gh-continue-on-street,
  gh-turn-slight-right,
  gh-turn-right,
  gh-turn-sharp-right,
  gh-finish,
  gh-use-roundabout,
  gh-u-turn,
  gh-keep-right,
  gps-1,
  gps,
  greek,
  info,
  info-grey,
  info-blue,
  layers,
  list,
  map,
  maps-and-location-1,
  maps-and-location-2,
  maps-and-location-3,
  maps-and-location-4,
  maps-and-location-5,
  maps-and-location-6,
  maps-and-location-7,
  maps-and-location,
  measuring-tape,
  menu,
  mobile-map,
  motorbike,
  next,
  padlock,
  pause,
  pause-white,
  photo,
  photo-grey,
  placeholders,
  play,
  play-white,
  playlist,
  playlist-active,
  prev,
  radar,
  route,
  route-active,
  route-white,
  rm-bike,
  rm-foot,
  rm-car,
  rm-scooter,
  rm-citymapper,
  rm-uber,
  rm-walk,
  screen,
  signpost,
  speak,
  speaker,
  satellite,
  search,
  star-fill,
  star-line,
  stop,
  stop-white,
  subtitles,
  support,
  swiper,
  swiper-active,
  tick,
  transportation-1,
  transportation,
  travel,
  wireless-connectivity,
  world-financial,
  wrench
);
.flat-icon {
  display: inline-block;
  vertical-align: middle;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  @each $picto in $pictos {
    &.picto-#{$picto} {
      background-image: url('./svg/#{$picto}.svg');
    }
  }
}

.flat-icons-list {
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
  overflow: auto;
  height: 100%;
  li {
    display: inline-block;
    width: 44px;
    padding: 15px;
    pre {
      display: block;
      vertical-align: middle;
      font-size: 9px;
      max-width: 100%;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
